import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaInstagram, FaYoutube, FaWhatsapp, FaFacebook } from "react-icons/fa";

// Import images (ensure file names match exactly)
import babyShower from "../assets/images/gallery/Baby-Shower - 03.jpg";
import baptism from "../assets/images/gallery/Baptism.jpg";
import birthday from "../assets/images/gallery/Birthday.jpg";
import cons from "../assets/images/gallery/consecration.jpg";
import ear_piercing from "../assets/images/gallery/ear piercing.jpg";
import first_holy_communion from "../assets/images/gallery/First holy communion.jpg";
import housewarm from "../assets/images/gallery/House warming - 01.jpg";
import kovilvizha from "../assets/images/gallery/Kovil kodai vizha.jpg";
import Namingcere from "../assets/images/gallery/Naming Ceremony.jpg";
import postwed from "../assets/images/gallery/Post Wedding.jpg";
import pubertycere from "../assets/images/gallery/Puberty Ceremony - 04.jpg";
import wedding from "../assets/images/gallery/Wedding.jpg";
import nbn from "../assets/images/nbn.png";
import gallery1 from "../assets/images/gallery1.jpg";

const Photos = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Preload critical images
  useEffect(() => {
    const images = [gallery1, babyShower, baptism, birthday, cons, ear_piercing, first_holy_communion, housewarm, kovilvizha, Namingcere, postwed, pubertycere, wedding];
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  // English names for categories
  const englishCategoryNames = {
    babyShower: "BABY SHOWER",
    pubertyFunction: "PUBERTY CEREMONY",
    Consecration: "CONSECRATION",
    earPiercingCeremony: "EAR PIERCING CEREMONY",
    tonsuringCeremony: "POST WEDDING",
    houseWarmingCeremony: "HOUSE WARMING CEREMONY",
    wedding: "WEDDING",
    firstHolyCommunion: "FIRST HOLY COMMUNION",
    birthday: "BIRTHDAY CEREMONY",
    baptism: "BAPTISM",
    kovilKodaiVila: "KOVIL KODAI VIZHA",
    nameCeremonyFunction: "NAMING CEREMONY",
  };

const handleCategoryClick = async (categoryName) => {
  const englishCategoryName = Object.keys(englishCategoryNames).find(
    (key) => t(`categories.${key}`) === categoryName
  );
  const englishName = englishCategoryName
    ? englishCategoryNames[englishCategoryName]
    : categoryName;
  //console.log("Category selected:", englishName);

  try {
    const response = await fetch(
      `https://backend.newbrindha.com/photostudio/user/fileupload?category=${englishName}`
    );
    const data = await response.json();
    //console.log(data);
    navigate(`/photo-details`, {
      state: { photos: response.ok ? data : [], category: englishName },
    });
  } catch (error) {
    //console.error("Error fetching images:", error);
    navigate(`/photo-details`, {
      state: { photos: [], category: englishName },
    });
  }
};


  const handleBackToHome = () => {
    navigate("/");
  };

  // Categories with optimized image references
  const categories = [
    { name: t("categories.babyShower"), image: babyShower },
    { name: t("categories.pubertyFunction"), image: pubertycere },
    { name: t("categories.Consecration"), image: cons },
    { name: t("categories.earPiercingCeremony"), image: ear_piercing },
    { name: t("categories.tonsuringCeremony"), image: postwed },
    { name: t("categories.houseWarmingCeremony"), image: housewarm },
    { name: t("categories.wedding"), image: wedding },
    { name: t("categories.firstHolyCommunion"), image: first_holy_communion },
    { name: t("categories.birthday"), image: birthday },
    { name: t("categories.baptism"), image: baptism },
    { name: t("categories.kovilKodaiVila"), image: kovilvizha },
    { name: t("categories.nameCeremonyFunction"), image: Namingcere },
  ];

  return (
    <>
      <div className="min-h-screen flex flex-col items-center bg-gray-500">
        {/* Header Section with Preload */}
        <div
          className="w-full h-56 bg-cover bg-center relative"
          style={{ backgroundImage: `url(${gallery1})` }}
        >
          <link rel="preload" href={gallery1} as="image" />
          <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4">
            <div className="text-white text-center">
              <Link to="/">
                <img
                  src={nbn}
                  alt="New Brindha Photography Logo"
                  className="h-10 sm:h-20 md:h-20 lg:h-20 ml-2"
                  loading="lazy"
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="w-full bg-white bg-opacity-80 sm:p-10 flex flex-col items-center space-y-8">
          <div className="w-full flex justify-between p-6">
            <h2 className="text-3xl sm:text-5xl font-semibold text-gray-900">
              GALLERY
            </h2>
            <button
              onClick={handleBackToHome}
              className="bg-orange-600 text-[#ffff] text-base sm:text-lg md:text-xl 
              font-semibold px-2 sm:px-2 md:px-4 py-1 sm:py-1 md:py-2 rounded-3xl shadow-lg hover:bg-opacity-80 transition-all duration-300 flex items-center"
            >
              <FaArrowLeft className="mr-2 mt-1" /> Back to Home
            </button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full max-w-6xl">
            {categories.map((category, index) => (
              <div
                key={index}
                onClick={() => handleCategoryClick(category.name)}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 cursor-pointer"
              >
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full aspect-[4/3] object-cover"
                  loading="lazy"
                />
                <div className="p-2 text-center">
                  <p className="text-sm sm:text-base text-gray-700 font-semibold line-clamp-1">
                    {category.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <footer className="bg-[#292929] text-[#FAFAFA] py-4 text-center w-full">
        <div className="container mx-auto px-4">
          <div className="flex justify-center gap-6 mb-4">
            <a
              href="https://www.instagram.com/new_brindha_studio_?igsh=MXE3ODRwZmJveHdsaw=="
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl text-gray-200 hover:text-pink-500 transition-colors duration-300"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.youtube.com/@NewBrindhaphotography"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl text-gray-200 hover:text-red-600 transition-colors duration-300"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
            <a
              href="https://wa.me/+919698995997"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl text-gray-200 hover:text-green-500 transition-colors duration-300"
              aria-label="WhatsApp"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.facebook.com/newbrindhaphotography"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl text-gray-200 hover:text-blue-600 transition-colors duration-300"
              aria-label="Facebook"
            >
              <FaFacebook />
            </a>
          </div>
          <p className="text-gray-200">© www.newbrindha.com. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Photos;